export const currentVersion = 0.6;
